(function () {
  'use strict';

  if (window.SpeakoutCustomerConfirmation) return;

  var dialog;
  var pending;
  var trigger;

  function finish(confirmed) {
    if (!pending) return;
    var resolve = pending;
    pending = null;
    if (dialog.open) dialog.close();
    document.body.classList.remove('speakout-customer-confirmation-open');
    if (trigger && trigger.isConnected) trigger.focus();
    trigger = null;
    resolve(confirmed);
  }

  function bind() {
    dialog = document.getElementById('SpeakoutCustomerConfirmationDialog');
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.dataset.customerConfirmationBound) return true;
    dialog.dataset.customerConfirmationBound = 'true';
    dialog.querySelector('[data-customer-confirmation-new]').addEventListener('click', function () {
      finish(true);
    });
    dialog.querySelector('[data-customer-confirmation-existing]').addEventListener('click', function () {
      finish(false);
    });
    dialog.querySelector('[data-customer-confirmation-close]').addEventListener('click', function () {
      finish(false);
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      finish(false);
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = Array.from(dialog.querySelectorAll('button, a[href]'));
      var first = controls[0];
      var last = controls[controls.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || !controls.includes(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !controls.includes(active))) {
        event.preventDefault();
        first.focus();
      }
    });
    dialog.addEventListener('close', function () {
      if (!dialog.open) finish(false);
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) finish(false);
    });
    return true;
  }

  window.SpeakoutCustomerConfirmation = {
    confirm: function (source) {
      if (pending || !bind()) return Promise.resolve(false);
      trigger = source || document.activeElement;
      return new Promise(function (resolve) {
        pending = resolve;
        try {
          dialog.showModal();
          document.body.classList.add('speakout-customer-confirmation-open');
          dialog.querySelector('#SpeakoutCustomerConfirmationTitle').focus();
        } catch (error) {
          finish(false);
        }
      });
    }
  };
})();
